"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputs = void 0;
const groupNames = __importStar(require("./group-names"));
const KnownProperties = __importStar(require("./known-properties"));
exports.inputs = [
    {
        groupName: groupNames.fanControlMode,
        propertyNames: [KnownProperties.fanControlMode]
    },
    {
        groupName: groupNames.fanQuantity,
        propertyNames: [KnownProperties.fanQuantity]
    },
    {
        groupName: groupNames.fanDefinition,
        propertyNames: [
            KnownProperties.fanDefinitionSpeed,
            KnownProperties.fanDefinitionStandardDensity
        ]
    },
    {
        groupName: groupNames.fanPerformanceMmodel,
        propertyNames: [
            KnownProperties.fanOutletArea,
            KnownProperties.fanDynamicPressureLossCoefficient
        ]
    },
    {
        groupName: groupNames.motorDefinition,
        propertyNames: [
            KnownProperties.motorInputPower,
            KnownProperties.motorPoles,
            KnownProperties.motorVoltage,
            KnownProperties.motorPhases,
            KnownProperties.motorGridPowerExponent,
            KnownProperties.motorCosphi
        ]
    },
    {
        groupName: groupNames.fanOperationalRange,
        propertyNames: [
            KnownProperties.fanMinimumSpeed,
            KnownProperties.fanMaximumSpeed
        ]
    },
    {
        groupName: groupNames.target,
        propertyNames: [KnownProperties.targetPressure]
    },
    {
        groupName: groupNames.airInput,
        propertyNames: [
            KnownProperties.airInputsTemperature,
            KnownProperties.airInputsHumidity,
            KnownProperties.airInputsPressure,
            KnownProperties.airInputsMassflow
        ]
    }
];
//# sourceMappingURL=inputs.js.map